export default __webpack_public_path__ + "static/media/GotTheTest-logo-dark.2eaf9654.jpg";